import { useCallback } from "react";
import { ethers } from "ethers";
import { useWeb3 } from "../context/Web3Context";
import { getUsdtContract } from "../web3/contracts";
import { ACTIVE_CONTRACTS } from "../config/app.config";

// Returns ensureAllowance(amountBN): checks USDT allowance to the purchase
// contract and approves (max) if it's insufficient. Returns when allowance
// is guaranteed >= amount.
export function useApprove() {
  const { signer, account } = useWeb3();

  const ensureAllowance = useCallback(
    async (amountBN) => {
      if (!signer || !account) throw new Error("NO_WALLET");
      const usdt = getUsdtContract(signer);
      const spender = ACTIVE_CONTRACTS.smartcorePurchase;

      const current = await usdt.allowance(account, spender);
      if (current.gte(amountBN)) return false; // already enough

      // Approve max so the user only ever approves once.
      const tx = await usdt.approve(spender, ethers.constants.MaxUint256);
      await tx.wait();
      return true; // an approval happened
    },
    [signer, account]
  );

  return { ensureAllowance };
}
